/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import EnvironmentInfo from '../../environment-info';
import { invokeRestApi } from '../../rest-client';
import * as MetadataUtils from '../../rules/rules-store';

const isFulfilled = <T>(p: PromiseSettledResult<T>): p is PromiseFulfilledResult<T> => p.status === 'fulfilled';

const importLocalizationAssets = async (userLocale: string | undefined) => {
  const availableLocales = EnvironmentInfo.getAvailableLocalePacks();
  const bundles = EnvironmentInfo.getLocalizationBundles(userLocale);
  let bundlesRequests;
  if (userLocale && availableLocales && availableLocales.includes(userLocale)) {
    bundlesRequests = [
      invokeRestApi('getLocalizationPack', {
        queryPayload: {
          locale: userLocale
        }
      })
    ];
  } else if (bundles.length > 0) {
    bundlesRequests = bundles.map((bundle) =>
      invokeRestApi('getLocalizationPack', {
        queryPayload: {
          version: bundle.pyBundleVersion,
          bundle: bundle.pyBundleName
        }
      })
    );
  }

  if (!bundlesRequests || bundlesRequests.length === 0) {
    return;
  }

  const successCode1 = 200;
  const successCode2 = 201;
  const bundleResponses = await Promise.allSettled(bundlesRequests);
  bundleResponses.filter(isFulfilled).forEach(({ value: bundle }) => {
    if ([successCode1, successCode2].includes(bundle.status) && bundle.data) {
      const localeJson = bundle.data;
      const localeUtilsStore = MetadataUtils.getLocaleUtilsForLanguage(userLocale ?? 'en-US');
      Object.keys(localeJson).forEach((key) => {
        localeUtilsStore.setLocaleForRule(localeJson[key], key);
      });
    }
  });
};

const loadLocalizationAssets = async (userLocale = EnvironmentInfo.getLocale()) => {
  try {
    await importLocalizationAssets(userLocale);
  } catch (e) {
    console.warn(e);
  }
};

export default loadLocalizationAssets;
